import SceButton from "../../../../Common/CommonComponents/sceButton"; 
//import Checkbox from "./SceCheckBox";
import ReactHtmlParser from 'react-html-parser';
import classes from './PbTermsCondition.scss';
import Checkbox from "./PbCheckbox";
import { getLocalizedStrings } from "./paperlessBillingPopupLocalisedstrings";

class PbTermsCondition extends React.Component {

  constructor(props) {
    super(props);
    this.strings = getLocalizedStrings('PbTNC');
    this.state = {
      showFullContent: false,
      buttonValue: this.strings.showMore,
      buttonIcon: 'downArrow',
      checkboxSelectedOption: false,
      selectedOptionIcon: false,
      isCheckboxClicked:this.props.isCheckboxClicked ? this.props.isCheckboxClicked:false,
    };
  }

  componentDidMount() {
    let contentType='PAPERLESS_BILLING_TNC';
    app.contentService.getContent(contentType).then((response) => {
      this.setState({ tncData: response[0].body });
    }, (error) => {
      app.logger.getLogger().info('error error::' + JSON.stringify(error));
    });
  }

  showMoreLess = () => {
    let showFullContent = !this.state.showFullContent;
    let buttonValue = (showFullContent) ? this.strings.showLess : this.strings.showMore;
    let buttonIcon = (showFullContent) ? 'upArrow' : 'downArrow';
    this.setState({ showFullContent: showFullContent, buttonValue: buttonValue, buttonIcon: buttonIcon });
  }


  handleCheckClick=async(e)=> {
    app.logger.getLogger().info("Paperless Billing Enroll: Checkbox clicked");
    await this.setState({ isCheckboxClicked: !this.state.isCheckboxClicked });
     this.props.handleTermsCallback(this.state.isCheckboxClicked);
}


printTnC() {
    var printWindow = window.open("", "", "left=0,top=0,width=800,height=500,scrollbars=1");
    var printContents = this.state.tncData;
    printWindow.document.write(printContents);
    printWindow.document.close();// necessary for IE >= 10
    printWindow.focus(); // necessary for IE >= 10
    setTimeout(() => {
      printWindow.print();
      !app.appUtil.detectMobile()? printWindow.close() : null;
    }, 1000);

  }


  render() {
    
    const tNcHeader = this.state.tncData ? (this.state.tncData).match(/<div id="tnc-header">([^`]*?)<\/div>/g) : '';
    const tNcContent = this.state.tncData ? (this.state.tncData).match(/<div id="tnc-content">([^`]*?)<\/div>/g) : '' ;
    return (
      <div className={classes.scePbTNC}>
        <div className={classes.scePrintLinkContainer}>
         <a className={classes.scePrintLink} onClick={() => this.printTnC()} href="javascript::void(0)"> Print </a> 
        </div>

        <div className={(this.state.showFullContent) ? classes.sceTNCFullContent : classes.sceTNCLessContent}>
            <div className={classes.sceTNCContent}>
                {ReactHtmlParser(tNcHeader)}
            </div>
            <div className={classes.sceTNCContent}>
                {ReactHtmlParser(tNcContent)}  
              </div>
         
        </div>

        { (!this.state.showFullContent && !this.props.hideGradientOpacity) ?
          <div className={classes.gradientContainer}>
            <div className={classes.gradientOpacity} />
          </div>
          :
          null
        }
<div className={classes.ShowMore}>
         <SceButton
          //buttonType='sceFullPrimary'
          value={this.state.buttonValue}
          iconType={this.state.buttonIcon}
          onClick={this.showMoreLess}
        /> 
        </div>
        <div className={this.props.showCheckboxError?classes.showErrorBorder:''}>
        <Checkbox type={"TermCheckBox"} className={classes.checkBoxContainer} id={'paperless_billing_tnc'} selectedOptions={this.state.isCheckboxClicked}
                                            selectedOptionIcon={this.props.tncChecked} options={this.strings.PbTNC} handleClick={(event) => this.handleCheckClick(event)}
                                        />
        </div>
      </div>
    );
  }
}
export default PbTermsCondition;


PbTermsCondition.dafaultProps={
  hasCheckboxError:false,
  isCheckboxDisabled:false,
  hideGradientOpacity:false,
};